"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labelStyles = exports.containerStyles = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../../utils/styleConsts");

var containerStyles = function containerStyles() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;flex-direction:column;align-items:center;justify-content:center;padding:5px;")
  );
};

exports.containerStyles = containerStyles;

var labelStyles = function labelStyles(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:28px;font-weight:", _styleConsts.font.weight.normal, ";color:", theme.color.black3, ";")
  );
};

exports.labelStyles = labelStyles;